import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { rootApi } from './services/rootApi';
import dashboardFilters from './features/dashboard/dashboardFilterState';
import globalUi from './features/global/globalUiState';
import crossSliceMiddleware from './middlewares/crossSliceMiddleware';
import { requestCleanupMiddleware } from './middlewares/requestCleanupMiddleware';

// Redux Slices
import course from './features/course/courseState';
import viewCourse from './features/viewCourse/viewCourseState';
import coursePage from './features/viewCourse/pageState';
import editCourse from './features/editCourse/editCourseState';
import courseGuide from './features/courseGuide/courseGuideState';

import campaigns from './features/campaigns/campaignsSlice';

// Webshop slices
import webshopCourse from './features/webshop/courseSlice';
import webshopCourses from './features/webshop/coursesSlice';
import webshopGlobal from './features/webshop/globalSlice';
import webshopHome from './features/webshop/homeSlice';
import webshopPayments from './features/webshop/paymentsSlice';
import webshopCart from './features/webshop/cartSlice';

export const store = configureStore({
  reducer: {
    [rootApi.reducerPath]: rootApi.reducer,
    globalUi,
    course,
    viewCourse,
    coursePage,
    editCourse,
    courseGuide,
    campaigns,
    dashboardFilters,
    webshop: combineReducers({
      home: webshopHome,
      course: webshopCourse,
      courses: webshopCourses,
      cart: webshopCart,
      global: webshopGlobal,
      payments: webshopPayments
    }),
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [
          'persist/PERSIST',
          'persist/REHYDRATE',
          `${rootApi.reducerPath}/executeQuery`,
          `${rootApi.reducerPath}/executeMutation`,
        ],
        ignoredPaths: [rootApi.reducerPath],
      },
    })
      .concat(rootApi.middleware)
      .concat(crossSliceMiddleware, requestCleanupMiddleware),
});

export default store;
